"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleAnalyticsPageviewObserver = /** @class */ (function () {
    function GoogleAnalyticsPageviewObserver(action, conditions) {
        if (conditions !== undefined && conditions !== null) {
            this.conditions = conditions;
        }
        this.action = action;
    }
    GoogleAnalyticsPageviewObserver.prototype.update = function (tracker, model) {
        if (model.get("hitType") !== GoogleAnalyticsPageviewObserver.hitType) {
            return;
        }
        var conditions = this.conditions;
        if (conditions === undefined
            || conditions.pagePath(model.get("page"))) {
            this.action(tracker, model);
        }
    };
    GoogleAnalyticsPageviewObserver.hitType = "pageview";
    return GoogleAnalyticsPageviewObserver;
}());
exports.default = GoogleAnalyticsPageviewObserver;
